import { composeIO } from 'react-compose-io'
import { semOcorrenciaBoxIO } from './SemOcorrenciaBox.IO'
import { SemOcorrenciaBoxView } from './SemOcorrenciaBox.View'

export const SemOcorrenciaBox = composeIO(SemOcorrenciaBoxView, semOcorrenciaBoxIO)
